import type * as lazyIndex from './lazyIndex';
import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import {
    onAfterSelectionChanged,
    resetSelection,
    toggleSelectRow,
    rangeSelectRow,
    keyboardMultiSelectRow,
} from 'owa-mail-actions/lib/mailListSelectionActions';
import onModuleClick from 'owa-workloads/lib/actions/onModuleClick';
import { selectedEventUpdated } from 'owa-calendar-surface-store-utils/lib/actions/selectedEventUpdated';
import onComposeRendered from 'owa-mail-compose-actions/lib/actions/onComposeRendered';
import onEditorFocused from 'owa-mail-compose-actions/lib/actions/onEditorFocused';
import activateTabAction from 'owa-tab-store/lib/actions/activateTabAction';
import onComposeLifecycleEvent from 'owa-mail-compose-store/lib/actions/onComposeLifecycleEvent';
import {
    onShowFullCompose,
    onCloseFullCompose,
} from 'owa-calendar-compose-form-store/lib/actions/formOpenCloseNotificationActions';
import {
    onSearchInputFocused,
    searchBoxBlurred,
    startSearch,
    exitSearch,
} from 'owa-search-actions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "BizchatMessagingOrchestration"*/ './lazyIndex'),
    { name: 'BizchatMessagingOrchestration' }
);

// Register lazy orchestrators
registerLazyOrchestrator(onModuleClick, lazyModule, m => m.onModuleClickOrchestrator);
registerLazyOrchestrator(selectedEventUpdated, lazyModule, m => m.selectedEventUpdatedOrchestrator);
registerLazyOrchestrator(
    onAfterSelectionChanged,
    lazyModule,
    m => m.onAfterSelectionChangedOrchestrator
);
registerLazyOrchestrator(resetSelection, lazyModule, m => m.resetSelectionOrchestrator);
registerLazyOrchestrator(toggleSelectRow, lazyModule, m => m.toggleSelectRowOrchestrator);
registerLazyOrchestrator(rangeSelectRow, lazyModule, m => m.rangeSelectRowOrchestrator);
registerLazyOrchestrator(
    keyboardMultiSelectRow,
    lazyModule,
    m => m.keyboardMultiSelectRowOrchestrator
);
registerLazyOrchestrator(onComposeRendered, lazyModule, m => m.onComposeRenderedOrchestrator);
registerLazyOrchestrator(activateTabAction, lazyModule, m => m.activateTabOrchestrator);
registerLazyOrchestrator(onComposeLifecycleEvent, lazyModule, m => m.onDiscardComposeOrchestrator);
registerLazyOrchestrator(onShowFullCompose, lazyModule, m => m.onShowFullComposeOrchestrator);
registerLazyOrchestrator(onCloseFullCompose, lazyModule, m => m.onCloseFullComposeOrchestrator);
registerLazyOrchestrator(onSearchInputFocused, lazyModule, m => m.onSearchInputFocusedOrchestrator);
registerLazyOrchestrator(searchBoxBlurred, lazyModule, m => m.onSearchBoxBlurredOrchestrator);
registerLazyOrchestrator(startSearch, lazyModule, m => m.onStartSearchOrchestrator);
registerLazyOrchestrator(exitSearch, lazyModule, m => m.onExitSearchOrchestrator);
registerLazyOrchestrator(onEditorFocused, lazyModule, m => m.onEditorFocusedOrchestrator);
